import CheckoutOrderMinimal from 'modules/checkout/products/CheckoutOrderMinimal';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';

export default function EstablishmentPageContent({ event, establishment }) {
    return (
        <Container fullyCentralized>
            <CheckoutOrderMinimal event={event} establishment={establishment} />
        </Container>
    )
}

const Container = styled(Column)`
  width: 100%;
  max-width: 700px;
  background-color: #fefefe;
  padding: 1rem;
  padding-bottom: 100px;
  margin: 0 auto;
`;
